import store from '../../../../store'

export default {
  patientWeight() {
    const patientData = store.getters['newAttendanceForm/patientData']
    return String(patientData.weight)
  },
  patientHeight() {
    const patientData = store.getters['newAttendanceForm/patientData']
    return String(patientData.height)
  },
}
